export default __webpack_public_path__ + "static/media/colonia.3a11a8e7.jpg";